import { Configuration, FrontendApi } from '@ory/client';

export const ory = new FrontendApi(
  new Configuration({
    basePath: 'https://identity.allbin.se',
    baseOptions: {
      withCredentials: true,
    },
  }),
);
